/**
 * 这个类创建一些用于需要平铺的Sprite
 */
TiledSpriteBuilder = xClass("TiledSpriteBuilder")

/**
 * 创建一个平铺背景图
 * @param fileName      图片名称
 * @param tiledNum      平铺倍数
 */
TiledSpriteBuilder.createTiledBackgrnd = function (fileName, tiledNum) {
    if (fileName && tiledNum) {
        var node = cc.TiledSprite.create(fileName);
        if (node) {
            node.setTiling(tiledNum.x, tiledNum.y);
            node.setScale(tiledNum.x, tiledNum.y);
            return node;
        } else {
            return null;
        }
    } else {
        return null;
    }
}